<template>

    <div class="app-radio-buttons" :class="{'has-error': error && error.length}">
        <label v-if="label" :id="label">{{ label }}</label>

        <div class="radio-buttons-wrap">
            <label class="radio-button-label" v-for="item in items">
                <input type="radio"
                       :id="`${name}-${item.value}`"
                       :name="name"
                       :disabled="disabled || loading"
                       v-model="newValue"
                       :value="item.value"
                       @input="onInput">
                <span class="radio-button-indicator"></span>
                <span class="radio-button-text">{{ item.name }}</span>
            </label>
        </div>

        <div class="loader" v-if="loading" v-html="$icon('loader')"></div>

        <p class="message" v-if="message">{{ message }}</p>
        <p class="error" v-if="error">{{ error }}</p>
    </div>

</template>

<script>

    export default {
        emits: ['update:modelValue', 'change'],

        name: 'app-input',

        props: {
            modelValue: [String, Number, Boolean],
            items: Array,
            label: String,
            name: String,
            message: String,
            error: String,
            loading: false,
            disabled: false
        },

        data() {
            return {
                newValue: this.modelValue,
                focused: false
            }
        },

        watch: {
            value() {
                this.newValue = this.modelValue;
            }
        },

        methods: {

            onInput(e) {
                this.newValue = e.target.value;

                this.$emit('update:modelValue', this.newValue);
                this.$emit('change', this.newValue);
            }

        },

        computed: {
            filled() {
                return this.newValue || this.focused
            },
        }

    }

</script>

<style lang="scss" scoped>

</style>
